<template>
  <Button
    :colour="colour"
    :href="href"
    :isClose="isClose"
    :isLink="isLink"
    :isDisabled="isDisabled"
    :text="text"
    :type="type"
    :isForm="isForm"
    :noBorder="noBorder"
    :isTabLink="isTabLink"
    :tabID="tabID"
  />
</template>

<script>
import Button from "../../components/Button/Button.vue";

export default {
  name: "app",
  components: {
    Button
  },
  data() {
    return {
      colour: this.$options._parentVnode.data.props.colour,
      href: this.$options._parentVnode.data.props.href,
      isClose: this.$options._parentVnode.data.props.isclose,
      isLink: this.$options._parentVnode.data.props.islink,
      isDisabled: this.$options._parentVnode.data.props.isdisabled,
      text: this.$options._parentVnode.data.props.text,
      type: this.$options._parentVnode.data.props.type,
      isForm: this.$options._parentVnode.data.props.isform,
      noBorder: this.$options._parentVnode.data.props.noborder,
      isTabLink: this.$options._parentVnode.data.props.istablink,
      tabID: this.$options._parentVnode.data.props.tabid
    };
  }
};
</script>
